import AddBookingModal from '../components/addBookingModal'
import AddProfileModal from '../components/addProfileModal'
import EditBookingModal from '../components/editBookingModal'
import FindProfileModal from '../components/findProfileModal'
import { IPatient } from '../interfaces'
import { useModal } from 'hooks'
import { t } from 'i18next'
import { IResponse } from 'interfaces/services'
import { IBooking } from 'pages/patientBooking/interfaces'
import { useRef } from 'react'

interface IProps {
  ignoreNavigate?: boolean
}

const useModalReceive = (props?: IProps) => {
  const modal = useModal()
  const keySearch = useRef('')

  const handleOnSearchPatient = (searchKey: string) => {
    keySearch.current = searchKey
    modal.open(
      <FindProfileModal phoneNumber={searchKey} />,
      {
        width: 920,
        title: t('find-profile')
      },
      (data: any) => {
        if (data?.isAddNew) {
          handleAddNewProfile()
          return
        }
        if (data) {
          handleAddNewBooking(data)
        }
      }
    )
  }

  const handleEditProfile = (
    patient: IPatient,
    callback?: (data: any) => void
  ) => {
    handleAddNewProfile(callback, patient)
  }

  const handleAddNewProfile = (
    callback?: (data: any) => void,
    patient?: IPatient
  ) => {
    modal.open(
      <AddProfileModal patient={patient} />,
      {
        title: patient?.user_id ? t('edit-new-profile') : t('add-new-profile'),
        footer: null,
        width: 1100
      },
      (data: any) => {
        if (data) {
          modal.close()
          if (callback) callback(data)
          return
        }
      }
    )
  }
  const handleAddNewBooking = (patient?: IPatient) => {
    modal.open(
      <AddBookingModal
        patient={patient}
        ignoreNavigate={props?.ignoreNavigate}
      />,
      {
        width: '90vw',
        title: t('booking-info'),
        footer: null
      }
    )
  }
  const handleEditBooking = (
    booking: IBooking,
    callback?: (data: IResponse<any>) => void
  ) => {
    modal.open(
      <EditBookingModal booking={booking} />,
      {
        width: 400,
        title: t('booking-info'),
        footer: null
      },
      callback
    )
  }
  return {
    handleOnSearchPatient,
    handleAddNewProfile,
    handleAddNewBooking,
    handleEditProfile,
    handleEditBooking
  }
}

export default useModalReceive
